"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocaleContext = void 0;
const react_1 = require("react");
exports.LocaleContext = react_1.createContext(undefined);
//# sourceMappingURL=locale-context.js.map